import { z } from "zod";
import { playncInfoSchema } from "@features/account/model/playncInfo.model";

const playncCompanyDataSchema = z.object({
  companyName: z.string(),
  companyStateCode: z.number(),
  iCafeId: z.string().optional(),
  isPrimary: z.boolean(),
  pcCafeAccount: z.string(),
  playncAccountId: z.string().uuid(),
  registeredAt: z.string(),
  sort: z.number(),
  updatedAt: z.string(),
});

export const accountInfoResponseSchema = z.object({
  accountStatus: z.number(),
  playncInfo: playncInfoSchema,
  playncCompanyData: playncCompanyDataSchema.optional(),
});

export type AccountInfoResponseType = z.infer<typeof accountInfoResponseSchema>;
